import { useEffect, useState } from "react";
import config  from "../config";

import getData from "../common/getData";
import hasProps from "../common/hasProps";
import { useKeycloak } from "@react-keycloak/web";

const ApiURL = `${config.app.apiBaseUrl}chatbots/v1/Chatmessages/Search`;

function useGetChatMessagesOnSearch(ChatMessageDataSearchFields){
  const [chatMessages, setChatMessages] = useState([]);
  const { keycloak } = useKeycloak();

  useEffect(
    function() {
      async function init() {
        if (!keycloak?.token) return;
        if (!hasProps(ChatMessageDataSearchFields)){
          setChatMessages([]);
          return chatMessages;
        };

        let chatMessagesList = await getData(keycloak.token, createParaURL(ApiURL, ChatMessageDataSearchFields), "json", false)
        if (chatMessagesList) {
          setChatMessages(chatMessagesList);
        }
      }
      init();
    },
    // eslint-disable-next-line
    [JSON.stringify(ChatMessageDataSearchFields)]
  );

  return {chatMessages};
}

function createParaURL(url, {ChatId, CurrentPage, AmountPerPage}){
  return url + `?ChatId=${encodeURIComponent(ChatId)}&CurrentPage=${encodeURIComponent(CurrentPage)}&AmountPerPage=${encodeURIComponent(AmountPerPage)}`
}

export default useGetChatMessagesOnSearch;